import React from "react";
import type {
  TextFieldProps,
  TextFieldRenderProps,
} from "react-aria-components";

export interface FCTextFieldContextInterface {
  /** Label text displayed above the field. */
  label?: string;
  /** Tooltip content shown next to the label. */
  labelTooltip?: string;
  /** Content displayed to the right of the label. */
  labelRight?: React.ReactNode;
  /** Helper text or description shown below the field. */
  description?: string;
  /** Validation error message (string) or validation function. */
  validate?: string | TextFieldProps["validate"];
  /** @internal Reference to the label element. */
  labelRef?: React.RefObject<HTMLLabelElement | null>;
  /** Field name for form submission. */
  name?: string;
  /** @internal Render props from react-aria TextField. */
  textFieldProps: TextFieldRenderProps;
}

export const FCTextFieldContext =
  React.createContext<FCTextFieldContextInterface>({
    textFieldProps: {
      isDisabled: false,
      isInvalid: false,
      isReadOnly: false,
      isRequired: false,
    },
  });
